<template>
  <fin-dropdown :disabled="disabled"
                :dropdown-height="dropdownHeight"
                :items="items"
                :value="selectedCategories"
                hide-all-selection
                label="Kategorien"
                show-selection-badge
                @input="val => selectedCategoriesChanged(val)">
    <template #default="{item}">
      {{ item.name }}
      <fin-circle :fill="item.color" :size="8" class="mx-3"/>
    </template>
  </fin-dropdown>
</template>

<script>
import FinDropdown from "@/components/common/Dropdown"
import FinCircle from "@/components/common/shapes/Circle"

export default {
  name: "finCategoryDropdown",
  components: {FinCircle, FinDropdown},
  props: {
    /** The selected category objects */
    value: {
      type: Array,
      default: () => []
    },
    /** All available category objects */
    items: {
      type: Array,
      default: () => []
    },
    /** Height of the dropdown */
    dropdownHeight: {
      type: String,
      default: '50vh'
    },
    /** Disables the v-menu dropdown */
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedCategories: this.value
    }
  },
  methods: {
    selectedCategoriesChanged(categories) {
      this.selectedCategories = categories

      /**
       * Returns the changed selection of the categories
       */
      this.$emit('input', categories)
    }
  },
  watch: {
    value(val) {
      this.selectedCategories = val
    }
  }
}
</script>

<style scoped>

</style>
